import React from "react";
import { Text } from '@mantine/core';

import { sqlDateToHumanDate, safeValue, getPropInSubLevelRole } from "../../utils/globalFunctions";
import LabelContentInline from "../../components/general/LabelContentInline";

const BarangFormCekData = ({ stateData }) => {
    return (
        <React.Fragment>
            <LabelContentInline
                stateColLabel={4}
                stateLabel='Nama Form'
                stateContent={stateData.barang_form_cek_name}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Status'
                stateContent={stateData.barang_form_cek_is_active === '1' ? 'Aktif' : 'Non Aktif'}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel={`List Item (${Array.isArray(stateData.barang_form_cek_detil) ? stateData.barang_form_cek_detil.length : 0})`}
                stateContent={Array.isArray(stateData.barang_form_cek_detil) ? Object.keys(stateData.barang_form_cek_detil).map((key, index) => {
                    return (
                        <Text key={key}>
                            {Number(index) + 1}. {stateData.barang_form_cek_detil[key].barang_form_cek_detil_name}
                        </Text>
                    )
                })
                    :
                    <Text>-</Text>
                }
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Tanggal Input'
                stateContent={sqlDateToHumanDate({
                    stateDate: stateData.barang_form_cek_created_datetime,
                    stateWithTime: true,
                    stateLang: 'id',
                    stateIsShort: false,
                    stateDay: false,
                    stateDefaultValue: ' - ',
                    stateDateType: 'day'
                })}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Diinput Oleh'
                stateContent={safeValue(stateData.barang_form_cek_created_user_name, '-')}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Jabatan'
                stateContent={getPropInSubLevelRole(stateData.barang_form_cek_created_user_sub_level, 'caption', '-')}
                stateDivider={false}
            />
        </React.Fragment>
    )
}

export default BarangFormCekData;